import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";

import {
  getSettingState,
  setLoadNavigation,
} from "../../../redux/features/settingSlice";
import UserCard from "../UserCard/UserCard";
import CustomModal from "../CustomModal";
import UserLoadingCard from "../UserCard/UserLoadingCard";
import { fetcherGetToken } from "../../../services/fetcher";

const ParticipantsModal = () => {
  const { customModal, participantsCount, participantsId, participantsType } =
    useSelector(getSettingState);
  const dispatch = useDispatch();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const conditionalReq = () => {
    let mode = null;
    if (customModal) {
      mode = `/content/${
        // condition request
        // (urlParams[1] === "profile" && profileTab === 1) ||
        // urlParams[1] === "" ||
        // urlParams[1] === "explore"
        participantsType === "table" ? "table" : "conversation"
      }/participants/${participantsId}/`;
    }
    return mode;
  };

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    data: participant,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;
      if (!customModal) return null;
      return [
        `${process.env.REACT_APP_API + conditionalReq()}?page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    {
      revalidateFirstPage: true,
      initialSize: 1,
    }
  );
  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const moreParticipantCart = size + 1 <= participant[0]?.total_pages;
    if (moreParticipantCart) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      setSize(participant[0].total_pages);
    }
  };

  const participantsList = () => {
    let participantList = [];
    if (participant) {
      // eslint-disable-next-line array-callback-return
      participant.map((e) => {
        participantList.push(...e.results);
      });
    }
    return participantList;
  };

  return (
    <Box>
      <CustomModal count={participantsCount} subject='Participants'>
        {isLoading || !participant
          ? Array(participantsCount)
              .fill("")
              .map((e, i) => {
                return <UserLoadingCard key={i} />;
              })
          : participantsList().map((row, i) => {
              return <UserCard key={row.id} rowData={row} firstIndex={i} />;
            })}
        {!isLoading && participant && (
          <Box
            ref={ref}
            sx={{ display: "flex", justifyContent: "center" }}
          ></Box>
        )}
      </CustomModal>
    </Box>
  );
};
export default ParticipantsModal;
